import { graphql } from '@/generated/gql';

export const INTAKE_REQUEST_RELEASE_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeRequestRelease($data: SvbrgIntakeRequestReleaseInput!) {
    sevenbridges {
      chatSession {
        request {
          release(data: $data)
        }
      }
    }
  }
`);

export const INTAKE_REQUEST_RESUBMIT_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeResubmit($data: SvbrgIntakeRequestReleaseInput!) {
    sevenbridges {
      chatSession {
        request {
          resubmit(data: $data)
        }
      }
    }
  }
`);
